import Draggable from 'vuedraggable';
import { range } from "lodash-es";

// 这个用于 Tabs 组件里，显示顶部那个页卡列表的

// events:
//   goto(index)
//   delete(index, event)
//   add(event)
//   sort({ oldIndex, newIndex })

const __script_base__ = {
  name: 'TabsList',
  components: {
    Draggable
  },
  model: {
    prop: 'current',
    event: 'goto'
  },
  props: {
    current: {
      type: Number,
      required: true
    },
    tabs: {
      type: Array,
      required: true
    },
    // { title, badgeText? }[]
    allowSort: {
      type: Boolean,
      default: false
    },
    allowAdd: {
      type: Boolean,
      default: false
    },
    allowDelete: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setCurrent(i) {
      this.$emit('goto', i);
    },
    handleDragEnd(ev) {
      this.$emit('sort', ev);
    },
    // 获取tab名称的对外方法
    getTabTitle(i) {
      var _this$tabs$i;
      return ((_this$tabs$i = this.tabs[i]) === null || _this$tabs$i === void 0 ? void 0 : _this$tabs$i.title) || '';
    }
  },
  computed: {
    dragIndices() {
      return range(this.tabs.length);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("draggable", {
    staticClass: "uc-tabs-list",
    attrs: {
      value: _vm.dragIndices,
      draggable: ".uc-tabs-item.isNormalItem",
      disabled: !_vm.allowSort,
      animation: 300
    },
    on: {
      end: _vm.handleDragEnd
    },
    nativeOn: {
      dragstart: function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._l(_vm.tabs, function (tab, index) {
    return _c("div", {
      key: "tab:" + index,
      staticClass: "uc-tabs-item isNormalItem",
      class: {
        isActive: index === _vm.current
      },
      attrs: {
        tabindex: "0",
        "data-index": index
      },
      on: {
        click: function ($event) {
          return _vm.setCurrent(index);
        }
      }
    }, [_c("div", {
      staticClass: "uc-tabs-item-text"
    }, [_vm._v("\n      " + _vm._s(tab.title || " - ") + "\n      "), tab.badgeText ? _c("div", {
      staticClass: "uc-tabs-item-badge"
    }, [_vm._v("\n        " + _vm._s(tab.badgeText) + "\n      ")]) : _vm._e()]), _vm._v(" "), _c("div", {
      staticClass: "uc-tabs-item-actionWrapper"
    }, [_vm.$scopedSlots.itemAction || _vm.allowDelete ? _c("div", {
      staticClass: "uc-tabs-item-action"
    }, [_vm.allowDelete ? _c("i", {
      staticClass: "fa fa-close",
      on: {
        click: function ($event) {
          $event.stopPropagation();
          return _vm.$emit("delete", index, $event);
        }
      }
    }) : _vm._e(), _vm._v(" "), _vm._t("itemAction", null, {
      tab: tab,
      index: index
    })], 2) : _vm._e()])]);
  }), _vm._v(" "), _vm.allowAdd ? _c("div", {
    staticClass: "uc-tabs-item isIcon",
    attrs: {
      slot: "footer"
    },
    on: {
      click: function ($event) {
        return _vm.$emit("add", $event);
      }
    },
    slot: "footer"
  }, [_c("i", {
    staticClass: "fa fa-plus"
  })]) : _vm._e()], 2);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Tabs/TabsList.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);